export default "__VITE_PUBLIC_ASSET__954e93cc__"